import { makeStyles } from "@mui/styles";

import FormTextField from "../../../components/UI/FormTextField";

const useStyles = makeStyles((theme) => ({
  textField: {
    "& label": {
      color: "#fff",
    },
    "& label.Mui-focused": {
      color: `${theme.primaryColor} !important`,
    },
    "& .MuiOutlinedInput-input": {
      backgroundColor: "transparent",
      color: "#fff",
      "&:-webkit-autofill": {
        transition: "background-color 5000s ease-in-out 0s",
        "-webkit-text-fill-color": "#fff !important",
      },
      "&:-webkit-autofill:hover": {
        transition: "background-color 5000s ease-in-out 0s",
        "-webkit-text-fill-color": "#fff !important",
      },
      "&:-webkit-autofill:focus": {
        transition: "background-color 5000s ease-in-out 0s",
        "-webkit-text-fill-color": "#fff !important",
      },
      "&:-webkit-autofill:active": {
        transition: "background-color 5000s ease-in-out 0s",
        "-webkit-text-fill-color": "#fff !important",
      },
    },
    "& .Mui-focused .MuiOutlinedInput-input": {
      color: `${theme.primaryColor} !important`,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#71B6BC",
    },
    "& fieldset": {
      borderColor: "white !important",
    },
    "&:hover fieldset": {
      borderColor: "white ",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#71B6BC",
    },
  },
  mbH20: {
    marginBottom: 20,
    marginTop: 20,
  },
}));

export default function AddMessageForm(props) {
  const { handleSubmit, control } = props;

  const classes = useStyles();

  const renderTextField = (options) => {
    const { name, label, inputProps } = options;
    return (
      <FormTextField
        fullWidth
        data-testId={name}
        name={name}
        label={label}
        size="small"
        variant="outlined"
        control={control}
        className={classes.textField}
        InputProps={{
          fullWidth: true,
        }}
        inputProps={
          inputProps || {
            autoComplete: "none",
          }
        }
      />
    );
  };

  const renderTextareaField = (options) => {
    const { name, label } = options;

    return (
      <FormTextField
        data-testId={name}
        className={classes.textField}
        fullWidth
        name={name}
        control={control}
        placeholder={label}
        multiline
        rows={3}
        label={label}
        size="small"
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        InputProps={{
          fullWidth: true,
        }}
        inputProps={{
          autoComplete: "none",
        }}
      />
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      {renderTextField({
        name: "name",
        label: "Name",
      })}
      {renderTextField({
        name: "phone",
        label: "Phone",
      })}
      {renderTextField({
        name: "email",
        label: "Email",
        inputProps: {
          autoComplete: "none",
          style: { borderColor: "#fff !important" },
        },
      })}
      {renderTextareaField({ name: "message", label: "Enter a message" })}
    </form>
  );
}
